module.exports = __webpack_public_path__ + "img/nuxt.92871113.png";